/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { schema3OtherReadCloneApiV1SandboxSessionsSessionIdGithubReadClonePost } from "../../funcs/schema3OtherReadCloneApiV1SandboxSessionsSessionIdGithubReadClonePost.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .ReadCloneApiV1SandboxSessionsSessionIdGithubReadClonePostRequest$inboundSchema,
};

export const tool$schema3OtherReadCloneApiV1SandboxSessionsSessionIdGithubReadClonePost:
  ToolDefinition<typeof args> = {
    name:
      "schema-3-other-read-clone-api-v1-sandbox-sessions-session-id-github-read-clone-post",
    description: `Read Clone`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await schema3OtherReadCloneApiV1SandboxSessionsSessionIdGithubReadClonePost(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
